import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _FontAwesomeIcon, _span;
var _excluded = ["hasError", "hint", "label", "PrefixIcon", "inputProps", "value", "onChange", "numberOfCharactersToGenerateOnButtonClick", "disabled"];
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import React, { forwardRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRotate } from '@fortawesome/pro-light-svg-icons';
import InputField from './../InputField';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "generate": "pbui-XYoh1",
  "generate--disabled": "pbui-HTW2P"
};
var ARRAY_OF_CHARACTERS = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];
var generateRandomCharacters = function generateRandomCharacters(N) {
  var randomString = '';
  var generatedNumberOfCharacters = 0;
  var ARRAY_OF_CHARACTERS_LENGTH = ARRAY_OF_CHARACTERS.length;
  while (generatedNumberOfCharacters < N) {
    var randomIndex = Math.floor(Math.random() * ARRAY_OF_CHARACTERS_LENGTH);
    randomString += ARRAY_OF_CHARACTERS[randomIndex];
    generatedNumberOfCharacters++;
  }
  return randomString;
};

// I had an error with the CodeGeneratorProps extending InputFieldProps, the typescript wasn't recognizing the props from InputFieldProps in the CodeGenerator.stories.tsx file

var CodeGenerator = /*#__PURE__*/forwardRef(function CodeGenerator(props, ref) {
  var hasError = props.hasError,
    hint = props.hint,
    label = props.label,
    PrefixIcon = props.PrefixIcon,
    inputProps = props.inputProps,
    value = props.value,
    onChange = props.onChange,
    _props$numberOfCharac = props.numberOfCharactersToGenerateOnButtonClick,
    numberOfCharactersToGenerateOnButtonClick = _props$numberOfCharac === void 0 ? 10 : _props$numberOfCharac,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    rest = _objectWithoutProperties(props, _excluded);
  var _React$useState = React.useState(value),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    inputValue = _React$useState2[0],
    setInputValue = _React$useState2[1];
  var handleOnChange = function handleOnChange(e) {
    var copyOfValue = e.target.value;
    var newValue = '';
    var _iterator = _createForOfIteratorHelper(copyOfValue),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var character = _step.value;
        if (ARRAY_OF_CHARACTERS.includes(character)) {
          newValue += character;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    e.target.value = newValue;
    setInputValue(newValue);
    if (onChange) onChange(e);
  };
  var handleOnClick = function handleOnClick() {
    if (disabled) return;
    var randomString = generateRandomCharacters(numberOfCharactersToGenerateOnButtonClick);
    setInputValue(randomString);

    // Create a synthetic event
    var syntheticEvent = {
      target: {
        value: randomString
      }
    };

    // Trigger the onChange prop with the synthetic event
    if (onChange) onChange(syntheticEvent);
  };
  return /*#__PURE__*/_jsx(InputField, _extends({
    ref: ref,
    type: "text",
    withDivider: true,
    value: inputValue,
    onChange: handleOnChange,
    SuffixIcon: function SuffixIcon() {
      return /*#__PURE__*/_jsxs("div", {
        className: "".concat(styles["generate"], " ").concat(disabled ? styles["generate--disabled"] : ""),
        onClick: handleOnClick,
        children: [_FontAwesomeIcon || (_FontAwesomeIcon = /*#__PURE__*/_jsx(FontAwesomeIcon, {
          icon: faRotate
        })), _span || (_span = /*#__PURE__*/_jsx("span", {
          children: "Generate"
        }))]
      });
    },
    hasError: hasError,
    hint: hint,
    label: label,
    PrefixIcon: PrefixIcon,
    inputProps: inputProps,
    disabled: disabled
  }, rest));
});
export default CodeGenerator;